import React from 'react'

export default function Error({ title }) {
    return (
        <p className='text-red-500 text-xs p-1'>{title}</p>
    )
}